import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-home",
  "use": "icon-icon-home-usage",
  "viewBox": "0 0 18.7 15.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.7 15.1\" id=\"icon-icon-home\"><defs><style>#icon-icon-home .cls-1{fill:none;stroke:#707072;stroke-miterlimit:10;}</style></defs><title>资源 1</title><g id=\"icon-icon-home_图层_2\" data-name=\"图层 2\"><g id=\"icon-icon-home_图层_1-2\" data-name=\"图层 1\"><polyline class=\"cls-1\" points=\"3.1 7 3.2 14.6 7.3 14.5 7.3 9.8 11.4 9.7 11.4 14.5 15.6 14.5 15.5 6.9\" /><polyline class=\"cls-1\" points=\"0.4 9.7 9.4 0.7 18.4 9.7\" /><polyline class=\"cls-1\" points=\"15.5 5.1 15.5 1.8 12.5 1.8\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-home.svg
// module id = bTi9
// module chunks = 72